// extracted by mini-css-extract-plugin
export default {"column":"Documents_column__hMlRe","containerList":"Documents_containerList__zqJ4U"};